/**
 * Copy Code Module
 * Adds copy buttons to all code blocks with syntax highlighting
 */

// SVG Icons
const COPY_ICON = `
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
`;

const CHECK_ICON = `
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
`;

export function initCopyCode() {
  // Find all pre elements with code blocks
  const codeBlocks = document.querySelectorAll('pre[class*="language-"]');

  codeBlocks.forEach((pre) => {
    // Extract language from class name
    const languageClass = pre.className.match(/language-(\w+)/);
    if (languageClass) {
      const language = languageClass[1];
      pre.setAttribute('data-language', language);
    }

    // Create wrapper for relative positioning
    const wrapper = document.createElement('div');
    wrapper.className = 'code-block-wrapper';

    // Wrap the pre element
    pre.parentNode.insertBefore(wrapper, pre);
    wrapper.appendChild(pre);

    // Create copy button
    const button = document.createElement('button');
    button.className = 'copy-code-button';
    button.innerHTML = COPY_ICON;
    button.setAttribute('aria-label', 'Copy code to clipboard');
    button.setAttribute('title', 'Copy code');

    // Add click handler
    button.addEventListener('click', async () => {
      const code = pre.querySelector('code');
      const text = code.textContent;

      try {
        await navigator.clipboard.writeText(text);

        // Show success feedback
        button.innerHTML = CHECK_ICON;
        button.classList.add('copied');
        button.setAttribute('title', 'Copied!');

        // Reset after 2 seconds
        setTimeout(() => {
          button.innerHTML = COPY_ICON;
          button.classList.remove('copied');
          button.setAttribute('title', 'Copy code');
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
        button.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        `;
        button.setAttribute('title', 'Failed to copy');

        setTimeout(() => {
          button.innerHTML = COPY_ICON;
          button.setAttribute('title', 'Copy code');
        }, 2000);
      }
    });

    // Add button to wrapper
    wrapper.appendChild(button);
  });
}
